import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../header';
import Navbar from '../navbar';
import Footer from '../footer';
import festivaldetailsData from '../../assets/jsons/Telugu/festivalDetails';
const Pandugavisistatha = () => {
  const { festivalId } = useParams();
  const navigate = useNavigate();
  // Filter valid categories
  const filteredCategories = [
    'dasaradescription',
    'vinayakavratam',
    'mahasivaratri',
    'christmas', 
    'sankranthi',
    'holi',
    'krishnastami',
    'deepavali',
    'rathayatra',
  ].reduce((acc, key) => {
    if (festivaldetailsData[key]) {
      acc[key] = festivaldetailsData[key];
    }
    return acc;
  }, {});
  const defaultKey = Object.keys(filteredCategories)[0];
  const currentKey = festivalId && filteredCategories[festivalId] ? festivalId : defaultKey;
  const activeCategory = filteredCategories[currentKey];
  const handleToggle = (key) => {
    navigate(`/pandugapramukyata/${key}`);
  };
  const renderCatIDList = (category) => {
    if (Array.isArray(category)) {
      return category.map((item, index) => (
        <div key={index}>
          <div>{item.title}</div>
          <div>{item.measure}</div>
        </div>
      ));
    } else if (category && category.CatID) {
      return category.CatID.map((item, index) => (
        <div key={index}>
          <div>{item.title}</div>
          <div>{item.measure}</div>
        </div>
      ));
    }
    return null;
  };
  return (
    <div>
      <Header />
      <Navbar />
      <div className="container-fluid bgColor">
        <div className="row">
          <div className="col-lg-1 col-md-1 leftFlowerImage"></div>
          <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 p-3">
            <div className="row">
              <div id="accordion">
                {Object.keys(filteredCategories).map((key, index) => (
                  <div
                    key={index}
                    id={`heading${index}`}
                    onClick={() => handleToggle(key)}
                    className="card-header card mb-3"
                    style={{
                      color: "#FFFFFF",
                      backgroundColor: currentKey === key ? '#B35C0C' : '#754213'
                    }}
                  >
                    <h5 className="mb-0">
                      <button
                        className="btn btn"
                        aria-expanded={currentKey === key}
                        aria-controls={`collapse${index}`}
                        style={{ color: '#FFFFFF' }}
                      >
                        {Array.isArray(filteredCategories[key]) ? key : filteredCategories[key].title}
                      </button>
                    </h5>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className="col-lg-5 col-md-5 col-sm-12 col-xs-12 p-3"
            style={{ maxHeight: '75vh', overflowY: 'auto', overflowX: 'hidden' }}
          >
            <div className="card-body rightPanel">
              <h5>{Array.isArray(activeCategory) ? currentKey : activeCategory.title}</h5>
              <ul>{renderCatIDList(activeCategory)}</ul>
              <br />
            </div>
          </div>
          <div className="col-lg-1 col-md-1 rightFlowerImage"></div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default Pandugavisistatha;




